import { HttpRequest } from './HttpRequest'

export const GetQCInspection = async (objectSearch: any): Promise<IGetQCInspection[]> => {
    let data = JSON.stringify(objectSearch)
    let result: IGetQCInspection[] = []
    try {
        const response = await HttpRequest().post(`/qc/inspection`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') 
            result = [{ unitCode: "", qcInspection: "", qcStatus: "" }].concat(response.data.responseData)

        return result
    } catch (error) {
        throw new Error
    }
}

export interface IGetQCInspection {
    unitCode: string
    qcInspection: string
    qcStatus: string
}